<template>
  <div @click="choseFile">
    <slot name="button"></slot>
    <input ref="excel" :id="id" type="file" class="file-hide" accept=".xlsx, .xls, .csv" @change="handleFileChange">
  </div>
</template>

<script>
  const XLSX = window.XLSX

  export default {
    name: 'excel',
    data() {
      return {
        id: 'file-' + Math.ceil(Math.random() * 1024),
        rawFile: null
      }
    },
    props: {
      type: {
        type: Number,
        default: 1
      }
    },
    methods: {
      primaryFormat(data) {
        let headers = {};
        let radius = {};
        let combine = {};
        let max = data['!ref'].replace('A1:', '').match(/([A-Za-z]+)(\d+)/)[2];
        let finalData = [];
        // 识别头部信息
        for (let key in data) {
          if (/([A-Za-z]+)(\d+)/.test(key)) {
            let matched = key.match(/([A-Za-z]+)(\d+)/);
            if (matched) {
              let index = matched[1], current = matched[2];

              // 如果是第一行，那就说明是臂长
              if (current == 1) {
                headers[index] = data[key]['w']
              } else if (index == 'A' && current != 1 && current != max) {
                // 如果是第一列，那就说明是作业半径
                radius[current] = data[key]['w']
              } else if (current == max && index != 'A') {
                // 如果是最后一行，那就说明是组合方式
                combine[index] = data[key]['w']
              }
            }
          }
        }

        // 识别内容区域
        for (let key in data) {
          if (/([A-Za-z]+)(\d+)/.test(key)) {
            let matched = key.match(/([A-Za-z]+)(\d+)/);
            if (matched) {
              let index = matched[1], current = matched[2];

              if (index != 'A' && current != 1 && current != max && data[key]['w'].replace(/\s/g, '')) {
                finalData.push({
                  primary_length: headers[index],
                  radius: radius[current],
                  way: combine[index],
                  weight: data[key]['w']
                })
              }
            }
          }
        }
        return finalData;
      },
      minorFormat(data) {
        let headers = {};
        let minors = {};
        let angle = {};
        let radius = {};
        let combine = {};
        let max = data['!ref'].replace('A1:', '').match(/([A-Za-z]+)(\d+)/)[2];
        let finalData = [];
        // 识别头部信息
        for (let key in data) {
          if (/([A-Za-z]+)(\d+)/.test(key)) {
            let matched = key.match(/([A-Za-z]+)(\d+)/);
            if (matched) {
              let index = matched[1], current = matched[2];

              // 如果是第一行，那就说明是臂长
              if (current == 1) {
                headers[index] = data[key]['w']
              } else if (current == 2) {
                minors[index] = data[key]['w']
              } else if (current == 3) {
                angle[index] = data[key]['w']
              } else if (index == 'A' && current != 1 && current != max) {
                // 如果是第一列，那就说明是作业半径
                radius[current] = data[key]['w']
              } else if (current == max && index != 'A') {
                // 如果是最后一行，那就说明是组合方式
                combine[index] = data[key]['w']
              }
            }
          }
        }

        // 识别内容区域
        for (let key in data) {
          if (/([A-Za-z]+)(\d+)/.test(key)) {
            let matched = key.match(/([A-Za-z]+)(\d+)/);
            if (matched) {
              let index = matched[1], current = matched[2];

              if (index != 'A' && current > 3 && current != max && data[key]['w'].replace(/\s/g, '')) {
                finalData.push({
                  primary_length: headers[index],
                  minor_length: minors[index],
                  angle: angle[index],
                  radius: radius[current],
                  way: combine[index],
                  weight: data[key]['w']
                })
              }
            }
          }
        }
        return finalData;
      },
      choseFile() {
        document.getElementById(this.id).click()
      },
      async handleFileChange(e) {
        if (this.rawFile !== null) {
          return
        }

        this.rawFile = e.target.files[0]

        let workbook = await this.fileConvertToWorkbook(this.rawFile)
        let data = workbook.Sheets[workbook.SheetNames[0]];
        let finalData = [];
        if (this.type == 1) {
          finalData = this.primaryFormat(data);
        } else if (this.type == 2) {
          // 副臂
          finalData = this.minorFormat(data);
        } else if (this.type == 3) {
          // 塔臂
        }

        this.rawFile = null
        this.$refs.excel.value = ''
        this.$emit('changeFile', finalData)
      },
      fileConvertToWorkbook (file) {
        let reader = new FileReader()
        let fixdata = (data) => {
          let o = "", l = 0, w = 10240
          for( ; l<data.byteLength/w ; ++l) {
            o += String.fromCharCode.apply(null,new Uint8Array(data.slice(l*w,l*w+w)))
          }
          o += String.fromCharCode.apply(null, new Uint8Array(data.slice(l*w)))
          return o
        }
        return new Promise((resolve, reject) => {
          try {
            reader.onload = (renderEvent) => {
              let data = renderEvent.target.result
              if(this.rABS) {
                /* if binary string, read with type 'binary' */
                resolve(XLSX.read(data, {type: 'binary'}))
              } else {
                /* if array buffer, convert to base64 */
                let arr = fixdata(data)
                resolve(XLSX.read(btoa(arr), {type: 'base64'}))
              }
            }
            reader.onerror = (error) => {
              reject(error)
            }
            if (this.rABS) {
              reader.readAsBinaryString(file)
            } else {
              reader.readAsArrayBuffer(file)
            }
          } catch (error) {
            reject(error)
          }
        })
      },
    }
  }
</script>

<style>
  .file-hide {display: none;}
</style>
